module.exports = __webpack_public_path__ + "static/rootstrap-3c5efbda9ec39e18f84135fe1bc15811.png";